<template>
  <v-form v-model="valid" ref="form">
    <v-row justify="space-between">
      <v-col cols="12" md="7">
        <!-- Advertiser -->
        <AdvertiserForm v-model="bannerTemplate.company" />
        <!-- Panel ID -->
        <div class="mb-1 subtitle-1 font-weight-bold">
          Banner Hash * -
          <span :class="[
            bannerTemplate.panelStatus ? 'success--text' : 'primary--text',
          ]">{{ bannerTemplate.panelStatusText || "N/A" }}</span>
        </div>
        <v-card outlined tile class="mb-6">
          <v-card-text class="py-1">
            <v-text-field v-model.trim="bannerTemplate.panelId" @change="setLivePreview"
              :rules="hashRule"></v-text-field>
          </v-card-text>
        </v-card>

        <!-- Offers ID -->
        <div class="mb-1 subtitle-1 font-weight-bold">Offers</div>
        <v-card outlined tile class="mb-6">
          <v-card-text class="py-1">
            <v-text-field v-model.trim.lazy="bannerTemplate.offers" @change="setLivePreview" required></v-text-field>
          </v-card-text>
        </v-card>

        <!-- subcampaigns ID -->
        <div class="mb-1 subtitle-1 font-weight-bold">Subcampaigns</div>
        <v-card outlined tile class="mb-6">
          <v-card-text class="py-1">
            <v-text-field v-model.trim.lazy="bannerTemplate.subcampaigns" @change="setLivePreview"
              required></v-text-field>
          </v-card-text>
        </v-card>

        <!-- Description -->
        <div class="mb-1 subtitle-1 font-weight-bold">Description</div>
        <v-card outlined tile class="mb-6">
          <v-textarea hide-details flat tile solo name="input-7-4" v-model="bannerTemplate.description"></v-textarea>
        </v-card>
        <!-- permissions -->
        <div class="mb-1 subtitle-1 font-weight-bold">Permissions *</div>
        <v-card outlined tile class="mb-6">
          <v-card-actions>
            <v-checkbox class="mx-2" dense color="primary" v-model="bannerTemplate.permission">
              <template v-slot:label>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" :class="[
                      bannerTemplate.permission
                        ? 'black--text'
                        : 'gray--text',
                      'subheading-1',
                    ]">
                      Permission to display
                    </div>
                  </template>
                  <span>Advertiser's permission to the publicate his
                    creations</span>
                </v-tooltip>
              </template>
            </v-checkbox>

            <!-- <v-checkbox class="mx-2" dense v-model="bannerTemplate.forceShow" :disabled="!user.superUser">
              <template v-slot:label>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" :class="[
                      bannerTemplate.forceShow ? 'black--text' : 'gray--text',
                      'subheading-1',
                    ]">
                      Force display
                    </div>
                  </template>
                  <span>Forcing the display of creations (ignores the current
                    status and consent of the advertiser)</span>
                </v-tooltip>
              </template>
            </v-checkbox> -->

            <v-checkbox class="mx-2" dense v-model="bannerTemplate.promote" :disabled="!user.superUser">
              <template v-slot:label>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" :class="[
                      bannerTemplate.promote ? 'black--text' : 'gray--text',
                      'subheading-1',
                    ]">
                      Show at the top
                    </div>
                  </template>
                  <span>Show at the top</span>
                </v-tooltip>
              </template>
            </v-checkbox>
          </v-card-actions>
        </v-card>
        <BannerLink :links="bannerTemplate.links" />
        <!-- tags -->
        <div class="mb-1 subtitle-1 font-weight-bold">Tags *</div>
        <v-card outlined tile class="mb-6">
          <v-card-text class="d-flex">
            <v-combobox v-model="selectedTags" multiple small-chips :hide-no-data="!search" :items="allTags"
              :search-input.sync="search" hide-selected @change="syncTags"
              :rules="[v => v.length > 0 || 'Tags reuired']">
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      No results matching "<strong class="primary--text">{{
                        search
                      }}</strong>". Press <kbd class="primary">Enter</kbd> to create a new
                      one
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-slot:selection="{ attrs, item, selected }">
                <v-chip :key="item" color="primary" v-bind="attrs" close small :input-value="selected" class="mb-1 mr-1"
                  @click:close="removeTag(item)"><span>{{ item }}</span>
                </v-chip>
              </template></v-combobox>
            <!-- <v-autocomplete
              v-model="selectedTags"
              :items="getTags"
              dense
              chips
              small-chips
              @input="addNewTag"
              multiple
              @change="syncTags"
            >
              <template v-slot:selection="{ attrs, item }">
                <v-chip
                  color="primary"
                  v-bind="attrs"
                  close
                  small
                  class="mb-1 mr-1"
                  @click:close="removeTag(item)"
                  >{{ item }}
                </v-chip>
              </template>
              <template v-slot:no-data>
                <v-list-item-group color="primary">
                  <v-list-item
                    >No data available.
                    <v-spacer></v-spacer>
                    <v-btn x-small color="primary" depressed @click="addNewTag"
                      >Add new tag</v-btn
                    >
                  </v-list-item>
                </v-list-item-group>
              </template>
            </v-autocomplete> -->
            <!-- <v-text-field
              placeholder="add Tag"
              v-model="newTag"
              @keydown.enter="onAddTag"
              dense
              class="pt-4 pb-0 mr-3"
            ></v-text-field>
            <v-btn
              tile
              text
              width="245"
              height="60"
              class="primary ml-4"
              @click="onAddTag"
              >Add tag</v-btn
            > -->
          </v-card-text>
        </v-card>
        <!-- categories -->
        <Category v-model="bannerTemplate.categories" />

        <!-- Actions -->
        <v-container>
          <v-row justify="end">
            <v-col cols="auto">
              <v-btn v-if="editing" tile outlined width="245" height="60" color="primary" class="mr-6"
                @click="dialogDelete = true">Delete</v-btn>
              <v-btn v-if="!editing" depressed tile color="primary" width="245" height="60"
                @click.prevent="onCreateBanner">Create Banner</v-btn>

              <v-btn v-if="editing" tile depressed width="245" height="60" color="primary"
                @click.prevent="onUpdateBanner" :disabled="!(user.email == bannerTemplate.creator || user.superUser)
                  ">Update Banner</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col cols="12" md="5">
        <v-card class="mb-5" flat outlined>
          <v-simple-table dense v-if="bannerTemplate.creator">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Action
                  </th>
                  <th class="text-left">
                    User
                  </th>
                  <th class="text-left">
                    Date
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Creation</td>
                  <td>{{ bannerTemplate.creator }}</td>
                  <td>{{ bannerTemplate.creationDate | date }}</td>
                </tr>
                <tr>
                  <td>Last edit</td>
                  <td>{{ bannerTemplate.lastEditor }}</td>
                  <td>{{ bannerTemplate.editDate | date }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
        <v-row flex-wrap justify="center" no-gutters>
          <v-col>
            <div class="mb-1 subtitle-1 font-weight-bold text-center">
              Static thumbnail * - {{ bannerTemplate.width }}x{{
                bannerTemplate.height
              }}
              <input type="file" id="image" name="thumb" accept="image/*" class="d-none" ref="file"
                @change="onFileChange" />
              <!-- <v-file-input
                type="file"
                name="thumb"
                accept="image/*"
                class="d-none"
                ref="file"
                @change="onFileChange"
              /> -->
            </div>
            <v-hover v-slot:default="{ hover }">
              <v-card flat :width="bannerTemplate.width || 300" :height="bannerTemplate.height || 600" tile
                class="red lighten-5 mx-auto mb-8">
                <label id="image">
                  <v-img cover height="100%" contain v-if="imgUrl" :src="imgUrl">
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <v-fade-transition>
                    <v-overlay v-if="hover || !imgUrl" absolute color="primary" opacity="0.9" z-index="12">
                      <v-btn large color="white" tile outlined @click="onClick">Upload image</v-btn>
                      <p v-show="bannerTemplate.thumb == undefined" class="mt-2 text-center">File is required*</p>
                    </v-overlay>
                  </v-fade-transition>
                </label>
              </v-card>
            </v-hover>
          </v-col>
          <v-col>
            <div class="subtitle-1 font-weight-bold text-center mb-1">
              Live preview
            </div>
            <!-- <v-hover v-slot:default="{ hover }"> -->
            <v-card flat tile :width="bannerTemplate.width || 300" :height="bannerTemplate.height || 600"
              class="red lighten-5 mx-auto d-flex align-center">
              <iframe sandbox="allow-scripts allow-same-origin allow-top-navigation"
                v-format-preview="bannerTemplate.liveUrl" frameborder="0" :width="bannerTemplate.width"
                :height="bannerTemplate.height" ref="frame"></iframe>
            </v-card>
            <!-- </v-hover> -->
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <BannerFormats v-model="bannerTemplate.otherFormats" :hash="bannerTemplate.panelId" @updateHash="updateHash"
              :advertiser="bannerTemplate.company" :offers="bannerTemplate.offers"
              :subcampaigns="bannerTemplate.subcampaigns" />
          </v-col>
        </v-row>
      </v-col>
      <v-dialog max-width="290" v-model="dialogDelete">
        <v-card>
          <v-card-title class="headline">Remove link</v-card-title>

          <v-card-text>Are you sure?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-1" outlined @click="dialogDelete = false">Cancel</v-btn>
            <v-btn color="primary darken-1" outlined @click="onDeleteBanner" :loading="loading">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-form>
</template>

<script>
import Vue from "vue";
import PreviewService from "@/common/services/preview";
import { mapActions, mapState, mapGetters } from "vuex";

export default Vue.extend({
  name: "BannerForm",
  data() {
    return {
      valid: false,
      newTag: "",
      overlay: false,
      dialogDelete: false,
      loading: false,
      liveUrl: "",
      additionalSizes: [],
      selectedTags: [],
      allTags: [],
      search: "",
      thumbRule: [(v) => !!v || "Thumb is required"],
      permishonRule: [(v) => !!v || "Hash is required"],
      hashRule: [(v) => !!v || "Hash is required"],
      bannerTemp: {
        permission: true,
        forceShow: false,
        hash: '',
        description: "",
        tags: "",
        liveUrl: "",
        panelId: "",
        offers: undefined,
        subcampaigns: undefined,
        thumb: null,
        company: {},
        categories: [],
        otherFormats: [],
        links: [
          {
            active: false,
            url: "",
            name: "",
          },
        ],
      },
      bannerTemplate: {}
    };
  },
  components: {
    AdvertiserForm: () => import("@/components/Dashboard/AdvertiserForm"),
    Category: () => import("@/components/Dashboard/CategoryForm"),
    BannerLink: () => import("@/components/Dashboard/BannerLink.vue"),
    BannerFormats: () => import("@/components/Dashboard/BannerFormats.vue"),
  },
  async mounted() {
    await this.fetchBanners();
    this.allTags = [...this.getTags];
    const banner = this.banner.banners.find(
      (banner) => banner._id === this.$route.params.id
    );
    this.bannerTemplate = Object.assign(this.bannerTemp, banner)
    this.initTags()
    // if (banner) {
    //   console.log(banner.tags);
    //   this.selectedTags = banner.tags.split(";");
    // }
  },

  computed: {
    ...mapState(["banner"]),
    ...mapGetters(["role", "user", "getTags"]),
    // bannerTemplate() {
    //   const banner = this.banner.banners.find(
    //     (banner) => banner._id === this.$route.params.id
    //   );
    //   const _banner = Object.assign(this.bannerTemp, banner)
    //   this.initTags()
    //   // syncTags()
    //   // console.log(banner?.tags);
    //   return _banner
    //   // return banner || this.bannerTemp;
    // },
    // getTags() {
    //   return this.bannerTemplate.tags
    //     ? this.bannerTemplate.tags.split(";")
    //     : [];
    // },
    imgUrl() {
      if (typeof this.bannerTemplate.thumb === "string")
        return `${process.env.VUE_APP_PUBLIC_URL}` + this.bannerTemplate.thumb;
      const file = this.bannerTemplate.thumb;
      if (file) return URL.createObjectURL(file);
      return null;
    },

    editing() {
      return this.bannerTemplate._id;
    },
  },
  // watch: {
  //   "bannerTemplate.company": function (newVal, oldVal) {
  //     this.removeTag(oldVal.verticalCategoryName || '');
  //     newVal.verticalCategoryName != undefined && newVal.verticalCategoryName !== '' && this.selectedTags.push(newVal.verticalCategoryName)
  //     this.syncTags()

  //   }
  // },
  methods: {
    ...mapActions([
      "createBanner",
      "updateBanner",
      "deleteBanner",
      "setSnackbar",
      "fetchBanners",
    ]),
    updateHash(val) {
      // this.bannerTemplate.panelId = val
      this.$set(this.bannerTemplate, "panelId", val);
      this.setLivePreview();
    },
    async setLivePreview() {
      this.bannerTemplate.liveUrl = "";
      this.bannerTemplate.width = 300;
      this.bannerTemplate.height = 600;
      if (this.bannerTemplate.panelId) {
        try {
          const { data } = await PreviewService.getBannersPreview({
            hash: this.bannerTemplate.panelId,
            offers: this.bannerTemplate.offers,
            subcampaigns: this.bannerTemplate.subcampaigns,
          });
          if (data.length < 1) {
            return;
          }

          let { previewUrl, width, height, status } = data[0];
          if (previewUrl.includes("/api/render/video/")) {
            width = 600;
            height = 380;
          }

          this.bannerTemplate.liveUrl = previewUrl;
          this.bannerTemplate.width = width;
          this.bannerTemplate.height = height;
          this.bannerTemplate.panelStatus = status.toLowerCase() == "active";
          this.bannerTemplate.panelStatusText = status;
        } catch (error) {
          console.log(error);
        }
      }
    },
    onClick() {
      this.$refs.file.click();
    },
    async onCreateBanner() {
      const formIsValid = this.$refs.form.validate();
      // return;
      // console.log(this.bannerTemplate.thumb)
      if (!formIsValid || this.bannerTemplate.thumb == undefined) return;
      // console.log(this.bannerTemplate)
      // this.bannerTemplate.liveUrl = `https://creatives-preview.rtbhouse.com/api/render/normal/${this.bannerTemplate.panelId}?disable_redirect_preview=false`;
      this.createBanner(this.bannerTemplate).then(() => {
        this.$router.push({ name: "dashboard" });
        this.setSnackbar({
          text: `Banner created.`,
        });
      });
    },
    onUpdateBanner() {
      const formIsValid = this.$refs.form.validate();
      if (!formIsValid) return;
      this.updateBanner(this.bannerTemplate).then(() => {
        this.$router.push({ name: "dashboard" });
        this.setSnackbar({
          text: `Banner updated.`,
        });
      });
    },
    async onDeleteBanner() {
      this.loading = true;
      this.deleteBanner(this.bannerTemplate._id);
      this.dialogDelete = false;
      this.loading = false;
      this.$router.push({ name: "dashboard" });
      this.setSnackbar({
        text: `Banner deleted`,
        color: "primary",
      });
    },
    initTags() {
      this.selectedTags = this.bannerTemplate?.tags.split(';')
    },
    syncTags() {
      this.bannerTemplate.tags = [...new Set([...this.selectedTags])]
        .filter((t) => t.length > 0)
        .join(";");
    },

    // onAddTag() {
    //   const newTag = this.newTag.toString().trim();
    //   this.bannerTemplate.tags = [
    //     ...new Set([...this.bannerTemplate.tags.split(";"), newTag]),
    //   ]
    //     .filter((t) => t.length > 0)
    //     .join(";");
    //   if (newTag.length === "") return;
    //   this.newTag = "";
    // },
    removeTag(tag) {
      // if (typeof tag !== "string")
      // console.log('tag to remove', tag)
      this.selectedTags = this.selectedTags.filter((v) => v !== tag);
      this.syncTags();
      // this.bannerTemplate.tags = this.bannerTemplate.tags
      //   .split(";")
      //   .filter((t) => t !== tag)
      //   .join(";");
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.bannerTemplate.thumb = file;
    },
    focusPreview() {
      this.$nextTick(() => this.$refs.refToElement.focus());
    },
  },
});
</script>

<style lang="scss">
iframe {
  position: relative;

  &:after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }
}
</style>